import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaStatusParcela = (): TabelaColuna => ({
  Chave: 'situacaoCobranca',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 130 }}>Status da parcela</div>
})
